// extracted by mini-css-extract-plugin
export default {"companyContainer":"cO-z","companyImage":"dO-z","container":"eO-z","heading":"fO-z","darkText":"gO-z","smallHeading":"hO-z","darkBackground":"iO-z","whiteBackground":"jO-z"};